/**
 * 건의와 문의를 합쳐 최신순 목록으로 정리하는 훅
 */
export const useRecentCommunications = ({ inquiries, suggests }) => {
  // 건의/문의는 각각 독립적인 id 시퀀스를 가지므로 출처를 태깅해 key 충돌을 방지한다
  const combinedData = [
    ...inquiries.map((item) => ({ ...item, __source: "inquiry" })),
    ...suggests.map((item) => ({ ...item, __source: "suggest" })),
  ].sort((a, b) => {
    return new Date(b.createdAt) - new Date(a.createdAt);
  });

  const slicedData = combinedData.slice(0, 9);

  return {
    slicedData,
  };
};
